<section class="littelAngelBg underinsured-hero">
  <div class="littelAngelHelpingWidth">
    <div class="littelAngelHelping">
      <h2>Are You Uninsured or Underinsured?</h2>
      <p>The NuLifeSpan Rx discount card can provide you with discounts on your prescription drugs, even if you don’t have insurance.</p>
    </div>
    <img src="../../assets/images/underinsured/underinsuredHero.png" />
  </div>
</section>
<img src="../../assets/images/seperator.svg" class="hero-seperator" />
<section class="littelAngelWelcomeWd">
  <div class="littelAngelWelcome">
    <h2>How Does the NuLifeSpan Rx Discount Card Work?</h2>
    <p>The NuLifeSpan Rx discount card works by providing you with access to discounted prices on prescription drugs at participating pharmacies. Simply present your card at the pharmacy to receive the discounted price. There are no limits on how many times you can use the card, and it
      can be used for all prescription medications, including brand-name and generic drugs.</p>
  </div>
  <div class="littelAngelWlVideo">
    <img src="../../assets/images/welcome_Rx.jpg">
    <img src="../../assets/images/underinsured/under_playicon.svg" class="playIcon">
  </div>
</section>
<section class="littelAngelService">
  <div class="littelAngelServiceWd">
   <div class="littelAngelLiner">
     <h2>Benefits of the NuLifeSpan Rx Discount Card for the Uninsured and Underinsured</h2>
     <p>The NuLifeSpan Rx discount card can be a lifesaver for those who are uninsured or underinsured. Here are some of the benefits of using the card:</p>
   </div>
   <div class="littelAngelTherapy">
     <div class="TherapyRow">
       <img src="../../assets/images/underinsured/without_insurance.svg">
       <div class="TherapyMod">
       <p>Discounts on prescription drugs, even without insurance</p>
       </div>
     </div>
     <div class="TherapyRow">
       <img src="../../assets/images/underinsured/no_restrictions.svg">
       <div class="TherapyMod">
       <p>No restrictions on usage, use the card as many times as you need</p>
       </div>
     </div>
     <div class="TherapyRow">
       <img src="../../assets/images/underinsured/drugs.svg">
       <div class="TherapyMod">
       <p>Savings on both brand-name and generic drugs</p>
       </div>
     </div>
     <div class="TherapyRow">
      <img src="../../assets/images/underinsured/pharmicies.svg">
      <div class="TherapyMod">
      <p>Easy to use, simply present the card at participating pharmacies</p>
      </div>
    </div>
    <div class="TherapyRow">
      <img src="../../assets/images/underinsured/pre_existing.svg">
      <div class="TherapyMod">
      <p>Available to everyone, regardless of income or pre-existing conditions</p>
      </div>
    </div>
   </div>
  </div>  
 </section>
 <section class="discountCard">
  <div class="discountCardRow">
    <div class="discountCardRowLeft">
      <h2>How to Get Your NuLifeSpan Rx Discount Card</h2>
      <p>Getting your NuLifeSpan Rx discount card is easy. Simply visit our website and fill out a short form to download and print your card. There are no fees or hidden costs, and the card is available to everyone.</p>
      <button class="" (click)="newDiscountModal()">Download Your Free Card Now</button>
    </div>
    <div class="discountCardRowRow">
      <img src="../../assets/images/getCard.png">
    </div>
  </div>
</section>
<section class="bestPrice adjust">
  <div class="bestPriceRow" id="bestPriceRowId">
    <div class="bestPriceLeft">
      <h2>Find the best prices on your prescriptions</h2>
      <p>Our pricing tool makes it easy to find the lowest prices on your medications. Simply enter the name of your drug, and we’ll show you the prices at pharmacies near you.</p>
      <nav-search></nav-search>
      <button>Find Lowest Price</button>
    </div>
    <img src="../../assets/images/underinsured/insured_prescriptions.png">
  </div>
</section>
 <!-- discount card start -->
 <div class="pharmacyPage newDiscountCardModal printView" *ngIf="newDisCardModal" id="printArea">
  <div class="discount_card"  id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseNewCardModal()"></div>

    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
          <div class="print" (click)="PrintMe()" data-after="Print"></div>
          </div>
        </div>
      
      <div class="pharmacyDetail">
       
        <div class="border-bottom"></div>
        
        <div class="discountModalTxt"><h5>For use at any major retail pharmacy and save!</h5></div>
          <div class="method_salt two">
          <div class="method">
            <div>bin</div>
            <div>023518</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>ARX</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>100-4542</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{newCardGroupNo}}</div>
          </div>
        </div>
        <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <!-- <div class="email_field" style="position: relative">
          <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="clearClassMsg()"
            autocomplete="off" />
          <label for="email">Enter your E-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div> -->
        <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
        <!-- <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            {{ PharmacistHelpline }}
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
 </div>